/* eslint-disable comma-dangle, no-var, react/jsx-closing-bracket-location, react/jsx-indent-props, react/prop-types, react/sort-comp */
/* TODO(csilvers): fix these lint errors (http://eslint.org/docs/rules): */
/* To fix, remove an entry above, run ka-lint, and fix errors. */

var React = require("react");
var ReactDOM = require("react-dom");
var _ = require("underscore");

var Util = require("../util.js");

var BlurInput = require("react-components/blur-input.jsx");
var InfoTip = require("../components/info-tip.jsx");

var answerTypes = {
    number: {
        name: "Numbers",
        forms: "integer, decimal, proper, improper, mixed"
    },
    decimal: {
        name: "Decimals",
        forms: "decimal"
    },
    integer: {
        name: "Integers",
        forms: "integer"
    },
    rational: {
        name: "Fractions and mixed numbers",
        forms: "integer, proper, improper, mixed"
    },
    improper: {
        name: "Improper numbers (no mixed)",
        forms: "integer, proper, improper"
    },
    mixed: {
        name: "Mixed numbers (no improper)",
        forms: "integer, proper, mixed"
    },
    percent: {
        name: "Numbers or percents",
        forms: "integer, decimal, proper, improper, mixed, percent"
    },
    pi: {
        name: "Numbers with pi",
        forms: "pi"
    }
};

var InputNumberEditor = React.createClass({
    displayName: "InputNumberEditor",

    propTypes: {
        value: React.PropTypes.number,
        simplify: React.PropTypes.oneOf(["required", "optional", "enforced"]),
        size: React.PropTypes.oneOf(["normal", "small"]),
        inexact: React.PropTypes.bool,
        maxError: React.PropTypes.number,
        answerType: React.PropTypes.string
    },

    getDefaultProps: function getDefaultProps() {
        return {
            value: 0,
            simplify: "required",
            size: "normal",
            inexact: false,
            maxError: 0.1,
            answerType: "number"
        };
    },

    handleAnswerChange: function handleAnswerChange(str) {
        var value = Util.firstNumericalParse(str) || 0;
        this.props.onChange({ value: value });
    },

    render: function render() {
        var _this = this;

        var answerTypeOptions = _.map(answerTypes, function (v, k) {
            return React.createElement(
                "option",
                { value: k, key: k },
                v.name
            );
        }, this);

        return React.createElement(
            "div",
            null,
            React.createElement(
                "div",
                null,
                React.createElement(
                    "label",
                    null,
                    "Correct answer:",
                    " ",
                    React.createElement(BlurInput, {
                        value: "" + this.props.value,
                        onChange: this.handleAnswerChange,
                        ref: "input"
                    })
                )
            ),
            React.createElement(
                "div",
                null,
                React.createElement(
                    "label",
                    null,
                    "Unsimplified answers",
                    " ",
                    React.createElement(
                        "select",
                        {
                            value: this.props.simplify,
                            onChange: function onChange(e) {
                                _this.props.onChange({
                                    simplify: e.target.value
                                });
                            }
                        },
                        React.createElement(
                            "option",
                            { value: "required" },
                            "will not be graded"
                        ),
                        React.createElement(
                            "option",
                            { value: "optional" },
                            "will be accepted"
                        ),
                        React.createElement(
                            "option",
                            { value: "enforced" },
                            "will be marked wrong"
                        )
                    )
                ),
                React.createElement(
                    InfoTip,
                    null,
                    React.createElement(
                        "p",
                        null,
                        "Normally select \"will not be graded\". This will give the user a message saying the answer is correct but not simplified. The user will then have to simplify it and re-enter, but will not be penalized. (5th grade and anything after)"
                    ),
                    React.createElement(
                        "p",
                        null,
                        "Select \"will be accepted\" only if the user is not expected to know how to simplify fractions yet. (Anything prior to 5th grade)"
                    ),
                    React.createElement(
                        "p",
                        null,
                        "Select \"will be marked wrong\" only if we are specifically assessing the ability to simplify."
                    )
                )
            ),
            React.createElement(
                "div",
                null,
                React.createElement(
                    "label",
                    null,
                    React.createElement("input", {
                        type: "checkbox",
                        checked: this.props.inexact,
                        onChange: function onChange(e) {
                            _this.props.onChange({
                                inexact: e.target.checked
                            });
                        }
                    }),
                    " ",
                    "Allow inexact answers"
                ),
                React.createElement(
                    "label",
                    null,
                    React.createElement("input", { /* TODO(emily): don't use a hidden checkbox
                                                   for alignment */
                        type: "checkbox",
                        style: { visibility: "hidden" }
                    }),
                    "Max error:",
                    " ",
                    React.createElement("input", {
                        type: "text",
                        disabled: !this.props.inexact,
                        defaultValue: this.props.maxError,
                        onBlur: function onBlur(e) {
                            var ans = "" + (Util.firstNumericalParse(e.target.value) || 0);
                            e.target.value = ans;
                            _this.props.onChange({ maxError: ans });
                        }
                    })
                )
            ),
            React.createElement(
                "div",
                null,
                "Answer type:",
                " ",
                React.createElement(
                    "select",
                    {
                        value: this.props.answerType,
                        onChange: function onChange(e) {
                            _this.props.onChange({ answerType: e.target.value });
                        }
                    },
                    answerTypeOptions
                ),
                React.createElement(
                    InfoTip,
                    null,
                    React.createElement(
                        "p",
                        null,
                        "Use the default \"Numbers\" unless the answer must be in a specific form (e.g., question is about converting decimals to fractions)."
                    )
                )
            ),
            React.createElement(
                "div",
                null,
                React.createElement(
                    "label",
                    null,
                    "Width",
                    " ",
                    React.createElement(
                        "select",
                        {
                            value: this.props.size,
                            onChange: function onChange(e) {
                                _this.props.onChange({ size: e.target.value });
                            }
                        },
                        React.createElement(
                            "option",
                            { value: "normal" },
                            "Normal (80px)"
                        ),
                        React.createElement(
                            "option",
                            { value: "small" },
                            "Small (40px)"
                        )
                    )
                ),
                React.createElement(
                    InfoTip,
                    null,
                    React.createElement(
                        "p",
                        null,
                        "Use size \"Normal\" for all text boxes, unless there are multiple text boxes in one line and the answer area is too narrow to fit them."
                    )
                )
            )
        );
    },

    focus: function focus() {
        ReactDOM.findDOMNode(this.refs.input).focus();
        return true;
    },

    serialize: function serialize() {
        return _.pick(this.props, "value", "simplify", "size", "inexact", "maxError", "answerType");
    }
});

module.exports = InputNumberEditor;


/*****************
 ** WEBPACK FOOTER
 ** ./src/widgets/input-number-editor.jsx
 ** module id = 70
 ** module chunks = 0 2
 **/